import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from "immutable";
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";

import TextInputField from '../../infra/components/formInput/CustomTextInput'
import ComboboxInput from '../../infra/components/formInput/ComboboxInput'
import DatePickerInput from '../../infra/components/formInput/DatePickerInput'

import ActionAdd from '../../store/action/ReportButton/Request'
import ActionGetAllUser from '../../store/action/Account/FetchAll'
import ActionGetAllClient from '../../store/action/Client/FetchAll'
import ActionGetAllDivision from '../../store/action/Division/FetchAll'
import ActionGetAllSender from '../../store/action/Sender/FetchAll'
import ActionGetAllTemplate from '../../store/action/TemplateHsm/Fetch'
import { IsEdit, IsCreate, IsView } from '../../store/constants'
import ActionGetAccessModuleIdAction from '../../store/action/AccessModule/FetchActionDispatch'
import { ClientId, DivisionId, SenderId, PrevilageId } from '../../helper/HelperAuth'
import moment, { now } from 'moment'

class Form extends Component {

  constructor(props) {
    super(props);
    this.state = {
      form: fromJS({
        'request-id': '',
        'request-date': '',
        'client-id': '',
        'division-id': '',
        'sender-id': '',
        'template-id': '',
        'header': '',
        'start-date': '',
        'end-date': '',
        'report-format': '',
        'button-format': ''

      }),
      reportFormat: fromJS([
        {
          'reportFormat-id': 1,
          'reportFormat-name': 'All'
        },
        {
          'reportFormat-id': 2,
          'reportFormat-name': 'Summary'
        },
        {
          'reportFormat-id': 3,
          'reportFormat-name': 'Detail'
        },
      ]),
      buttonFormat: fromJS([
        {
          'buttonFormat-id': 4,
          'buttonFormat-name': 'Push Button'
        }
       ,
        {
          'buttonFormat-id': 5,
          'buttonFormat-name': 'Interactive Button'
        }
      ]),
      loadded: false,
      disabled: false,
      errors: fromJS({}),
      error: '',
      actionId: "",
      disableHead: true,
      disabledheader: true,
      disabledtemplate: true
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  componentDidMount() {
    this.props.actionGetAllUser();
    this.props.actionGetAllClient();
    this.props.actionGetAccessModuleIdAction('Report Button');
  }

  handleChange(field, value, label) {
    var formVal = this.state.form;
    formVal = formVal.set(field, value);

    if (field === 'client-id') {
      this.props.actionGetAllDivision(value);
      this.props.actionGetAllSender(value);
      this.props.actionGetAllTemplate(value)
    }

    if (field === 'button-format') {
      if (value == 4) {
        this.setState({ disabledtemplate: false, disabledheader: true })
        formVal = formVal.set('header', '')
      } 
      else if (value == 5) {
        this.setState({ disabledtemplate: true, disabledheader: false })
        formVal = formVal.set('template-id', '')
      } 
      else {
        this.setState({ disabledtemplate: true, disabledheader: true })
        formVal = formVal.set('header', '').set('template-id', '')
      }
    }

    this.setState({ form: formVal })
  }

  async handleSubmit(dispatch) {
    const { form } = this.state;
    var isValid = true;
    var mandatoryField = fromJS([]);
    var newErrors = fromJS({});

    mandatoryField.map((field) => {
      if (form.get(field) === '') {
        isValid = false;
        newErrors = newErrors.set(field)
      }
    })

    this.setState({ errors: newErrors })

    if (!isValid) {
      toast.error("Mandatory Field Cannot Empty!", toast.POSITION.TOP_RIGHT)
    }

    if (isValid) {

      switch (this.props.actionType) {
        case IsCreate:
          await this.SubmitNewData();
          break;
        default:
        // code blocks
      }

    }
  }

  async SubmitNewData() {
    const form = this.state.form;
    var data =
    {
      'filter':
      {
        'client-id': form.get('client-id'),
        'division-id': form.get('division-id'),
        // eslint-disable-next-line radix
        'sender-id': form.get('sender-id') == '' ? "" : parseInt(form.get('sender-id')),
        'start-date': `${form.get('start-date')} 00:00:00`,
        'end-date': `${form.get('end-date')} 23:59:59`,
        'template-id': form.get('template-id'),
        'report-format': form.get('report-format'),
        'button-format': form.get('button-format'),
        'header': form.get('header'),

      }
    };
    var response = await this.props.actionAdd(data);
    if (response.ok) {
      toast.success('Save Success!', toast.POSITION.TOP_RIGHT);
      this.props.handleCancelForm(true);
    } else {
      //toast.error('Save Failed', toast.POSITION.TOP_RIGHT);
    }
  }

  handleCancel() {
    this.props.handleCancelForm(false);
  }

  componentWillMount() {
    if (this.props.item != null || this.props.item !== undefined) {
      if ((this.props.actionType === IsCreate) && !this.state.loadded) {
        var varActionId = "";
        var dataAkses = null;

        setTimeout(() => {
          dataAkses = this.props.accessmoduleaction;
          if (dataAkses) {
            varActionId = dataAkses.get("action-id");
            this.setState({ actionId: varActionId });
            if (varActionId == 5) {
              this.props.actionGetAllDivision(ClientId);
              this.props.actionGetAllTemplate(ClientId, SenderId, varActionId)
              this.props.actionGetAllSender(ClientId);
              this.setState({
                form: fromJS({
                  'client-id': ClientId,
                  'division-id': DivisionId,
                  'sender-id': SenderId,
                  'template-id': '',
                  'start-date': '',
                  'end-date': '',
                  'report-format': ''
             //     'header': ''
                }),
                loadded: true,
                disableHead: true
              })
            } else {
              this.setState({
                form: fromJS({
                  'client-id': '',
                  'division-id': '',
                  'sender-id': '',
                  'template-id': '',
                  'start-date': '',
                  'end-date': '',
                  'report-format': ''
               // ,
               //   'header': '',
                }),
                loadded: true,
                disabled: (this.props.actionType === IsView),
                disableHead: false
              })
            }
          }
        }, 8000);
      }
    }
  }

  render() {
    const { form, errors, reportFormat, disabled, buttonFormat } = this.state;
    return (
      <div className="card no-margin-bottom">
        <div className="body">
          <div className="row no-margin-bottom">
            <span className="col-sm-2">Client *</span>
            <div className="col-sm-10">
              <ComboboxInput
                field='client-id'
                value={form.get('client-id')}
                options={fromJS({
                  'source': this.props.clientall,
                  'value': 'client-id',
                  'label': 'client-name'
                })}
                onChange={(field, value, label) => this.handleChange(field, value, label)}
                placeholder="Client"
                disabled={this.state.disableHead}
                hasError={errors.has('client-id')}
              />
            </div>
          </div>

          <div className="row no-margin-bottom">
            <span className="col-sm-2">Division *</span>
            <div className="col-sm-10">
              <ComboboxInput
                field='division-id'
                value={form.get('division-id')}
                options={fromJS({
                  'source': this.props.divisionall,
                  'value': 'division-id',
                  'label': 'division-name'
                })}
                onChange={(field, value, label) => this.handleChange(field, value, label)}
                placeholder="Division"
                disabled={this.state.disableHead}
                hasError={errors.has('division-id')}
              />
            </div>
          </div>

          <div className="row no-margin-bottom">
            <span className="col-sm-2">Sender *</span>
            <div className="col-sm-10">
              <ComboboxInput
                field='sender-id'
                value={form.get('sender-id')}
                options={fromJS({
                  'source': this.props.senderall,
                  'value': 'sender-id',
                  'label': 'sender-name'
                })}
                onChange={(field, value, label) => this.handleChange(field, value, label)}
                placeholder="Sender"
                disabled={this.state.disableHead}
                hasError={errors.has('sender-id')}
              />
            </div>
          </div>
          <div className="row no-margin-bottom">
            <span className="col-sm-2">Report Format *</span>
            <div className="col-sm-10">
              <ComboboxInput
                field='report-format'
                value={form.get('report-format')}
                options={fromJS({
                  'source': reportFormat,
                  'value': 'reportFormat-id',
                  'label': 'reportFormat-name'
                })}
                onChange={(field, value, label) => this.handleChange(field, value, label)}
                placeholder="Report Format"
                disabled={disabled}
                hasError={errors.has('report-format')}
              />
            </div>
          </div>
          <div className="row no-margin-bottom">
            <span className="col-sm-2">Button Format *</span>
            <div className="col-sm-10">
              <ComboboxInput
                field='button-format'
                value={form.get('button-format')}
                options={fromJS({
                  'source': buttonFormat,
                  'value': 'buttonFormat-id',
                  'label': 'buttonFormat-name'
                })}
                onChange={(field, value, label) => this.handleChange(field, value, label)}
                placeholder="Button Format"
                disabled={disabled}
                hasError={errors.has('button-format')}
              />
            </div>
          </div>


          <div className="row no-margin-bottom">
            <span className="col-sm-2">Start Date</span>
            <div className="col-sm-10">
              <DatePickerInput
                dateFormat="yyyy-MM-dd"
                convertvalue
                field="start-date"
                value={form.get('start-date')}
                onChange={(field, date) => this.handleChange(field, date)}
                minDate={new Date(moment().subtract(3, "month").format("YYYY-MM-DD "))}
                maxDate={new Date()}
              />
            </div>
          </div>

          <div className="row no-margin-bottom">
            <span className="col-sm-2">End Date</span>
            <div className="col-sm-10">
              <DatePickerInput
                convertvalue
                dateFormat="yyyy-MM-dd"
                field="end-date"
                value={form.get('end-date')}
                onChange={(field, date) => this.handleChange(field, date)}
                minDate={form.get("start-date") == null 
                || form.get("start-date") == undefined 
                || form.get("start-date") == "" ? new Date(moment().subtract(3, "month").format("YYYY-MM-DD "))
                :new Date(form.get("start-date"))}
                maxDate={new Date()}
              />
            </div>
          </div>
          <div className="row no-margin-bottom">
            <span className="col-sm-2">Template</span>
            <div className="col-sm-10">
              <ComboboxInput
                field='template-id'
                value={form.get('template-id')}
                options={fromJS({
                  'source': this.props.templateall,
                  'value': 'template-id',
                  'label': 'template-name'
                })}
                onChange={(field, value, label) => this.handleChange(field, value, label)}
                placeholder="Template"
                disabled={this.state.disabledtemplate}
                hasError={errors.has('template-id')}
              />
            </div>
          </div>
          <div className="row no-margin-bottom">
            <span className="col-sm-2">Header</span>
            <div className="col-sm-10">
              <TextInputField className="form-control"
                field={'header'}
                value={form.get('header')}
                onChange={(field, value) => this.handleChange(field, value)}
                placeholder="Header Button"
                disabled={this.state.disabledheader}
                hasError={errors.has('header')}
              />
            </div>
          </div>
          <div className="row no-margin-bottom">
            <span className="col-sm-2"></span>
            <div className="col-sm-10">
              <button type="button"
                className="btn btn-wide btn-danger"
                value="Cancel"
                onClick={this.handleCancel}>
                Cancel
              </button>
              <button type="button"
                className="btn btn-wide btn-success"
                onClick={this.handleSubmit}>
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }


}


export default connect(
  (state) => {
    return {
      Users: state.user.users,
      userall: state.user.userall,
      clientall: state.user.clientall,
      divisionall: state.user.divisionall,
      senderall: state.user.senders,
      templateall: state.user.templateall,
      accessmoduleaction: state.user.accessmoduleaction,
    }
  },
  dispatch => bindActionCreators({
    actionAdd: ActionAdd,
    actionGetAllUser: ActionGetAllUser,
    actionGetAllClient: ActionGetAllClient,
    actionGetAllDivision: ActionGetAllDivision,
    actionGetAllSender: ActionGetAllSender,
    actionGetAllTemplate: ActionGetAllTemplate,
    actionGetAccessModuleIdAction: ActionGetAccessModuleIdAction,
  }, dispatch),
)(Form);